import React from 'react';
import logo from '../../../../../assets/images/logo.svg';
import submitIcon from '../../../../../assets/images/submittedIcon.svg';
import './style.scss';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../../Shared/components/controls/Button/index';

const DocumentStepTwo = ({ t }) => {
  return (
    <div className="StepThreecontainer">
      {/* header */}

      <div className="titleContainer">
        <span className="title">{t('DocumentStepTwoTitle')}</span>
        <span className="subTitle">{t('DocumentStepTwoSubtitle')}</span>
      </div>
      {/* sub Header */}
      <div className="subHeader">
        <div className="firstSpan">
          <span>{t('DocumetnStepTwoFirstSpanText')} </span>
        </div>
      </div>
      {/* card  */}
      <div className="submitCard">
        <img src={submitIcon} alt="submit icon" className="submitIcon" />
        {/* card text */}
        <div className="cardText">
          <div className="cardTitle">
            <span>{t('CardLimitReset')}</span>
          </div>
          <div className="cardSubTitle">
            <span>{t('CardSubTitleText')}</span>
          </div>
        </div>
      </div>
      {/* <div className='btn'>
        <Button>Complete</Button>
      </div> */}
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(DocumentStepTwo));
